import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Youtube, Twitter, Facebook, Mail, MapPin } from 'lucide-react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Company Info */}
            <div className="footer-section">
              <img src="/logo.png" alt="Aurexa Technologies" className="footer-logo" />
              <p className="footer-desc">
                Shaping the future of regulated industries with compliant, intelligent, 
                and scalable digital solutions.
              </p>
              <div className="footer-social">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <Linkedin size={20} />
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                  <Youtube size={20} />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <Twitter size={20} />
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <Facebook size={20} />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul className="footer-links">
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About Us</Link></li>
                <li><Link to="/industries">Industries</Link></li>
                <li><Link to="/careers">Careers</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>

            {/* QC-Metric Modules */}
            <div className="footer-section">
              <h4>QC-Metric</h4>
              <ul className="footer-links">
                <li><Link to="/products/qc-metric">Overview</Link></li>
                <li><Link to="/products/content-management">Content Management</Link></li>
                <li><Link to="/products/training-management">Training Management</Link></li>
                <li><Link to="/products/quality-management">Quality Management</Link></li>
                <li><Link to="/products/workflow-forms">Workflow Based Forms</Link></li>
              </ul>
            </div>

            {/* Contact */}
            <div className="footer-section">
              <h4>Contact Us</h4>
              <ul className="footer-contact">
                <li>
                  <Mail size={16} />
                  <a href="mailto:contact@aurexatech.com">contact@aurexatech.com</a>
                </li>
                <li>
                  <Mail size={16} />
                  <a href="mailto:support@aurexatech.com">support@aurexatech.com</a>
                </li>
                <li>
                  <MapPin size={16} />
                  <span>Global Offices</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-content">
            <p>© {currentYear} Aurexa Technologies. All rights reserved.</p>
            <p className="footer-compliance">
              Validated to global standards (GxP, FDA 21 CFR Part 11, ISO, GDPR, HIPAA)
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
